'use client';
import { type PropsWithChildren, useRef } from 'react';
import { Provider } from 'react-redux';
import { makeStore, type AppStore } from '@witmetrics/data-store';

export default function ReduxProvider({ children }: PropsWithChildren) {
  // Per-request store (SSR-safe) — instantiated once per render via the ref.
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) storeRef.current = makeStore();
  return <Provider store={storeRef.current}>{children}</Provider>;
}
